import React, { useState } from "react";
import {
  Button,
  FormControl,
  FormLabel,
  Image,
  Input,
  InputGroup,
  InputRightElement,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import toast from "react-hot-toast";
import calendarIcon from "../../../assets/images/onleave/calendar.svg";
import { attendanceCall } from "../../../api/attendance";

const FormStandardWorking = ({ isOpen, onClose, onUpdated }) => {
  const [date, setDate] = useState(new Date());
  const [totalStandardWorking, setTotalStandardWorking] = useState("");
  const [isUpdating, setIsUpdating] = useState(false);

  const now = new Date();
  const isCurrentMonth =
    date &&
    date.getMonth() === now.getMonth() &&
    date.getFullYear() === now.getFullYear();

  const handleUpdate = async () => {
    if (!date) {
      toast.error("Vui lòng chọn tháng");
      return;
    }

    const value = Number(totalStandardWorking);
    if (totalStandardWorking === "" || Number.isNaN(value) || value < 0 || value > 31) {
      toast.error("Số ngày công chuẩn phải từ 0 đến 31");
      return;
    }

    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    setIsUpdating(true);
    const toastId = toast.loading("Đang sửa ngày công chuẩn...");
    try {
      const result = await attendanceCall.updateStandardWorking(
        month,
        year,
        value,
      );
      toast.success(
        `Đã sửa ngày công chuẩn tháng ${month}/${year} cho ${result?.matchedCount || 0} bản ghi` +
          (result?.lockedCount
            ? `, bỏ qua ${result.lockedCount} bản ghi đã chốt`
            : ""),
      );
      onUpdated?.();
      onClose();
    } catch (error) {
      console.error(error);
    } finally {
      toast.dismiss(toastId);
      setIsUpdating(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        backgroundColor="var(--color-main)"
        borderRadius={"16px"}
        padding={"8px"}
        maxW={"420px"}
      >
        <ModalHeader
          fontSize={"18px"}
          fontWeight={600}
          color={"var(--color-header-employee)"}
        >
          Sửa ngày công chuẩn
        </ModalHeader>
        <ModalBody>
          <FormControl mb={"16px"}>
            <FormLabel
              fontSize={"12px"}
              fontWeight={400}
              color={"var(--color-label-employee)"}
              mb={"6px"}
            >
              Tháng / Năm
            </FormLabel>
            <InputGroup>
              <DatePicker
                selected={date}
                onChange={(value) => setDate(value)}
                dateFormat="MM/yyyy"
                locale="vi"
                showMonthYearPicker
                placeholderText="mm/yyyy"
                className="datePickerStyle"
                portalId="datepicker-portal"
                popperProps={{ strategy: "fixed" }}
                style={{ width: "100%" }}
              />
              <InputRightElement pointerEvents="none" h={"44px"}>
                <Image src={calendarIcon} />
              </InputRightElement>
            </InputGroup>
          </FormControl>

          <FormControl>
            <FormLabel
              fontSize={"12px"}
              fontWeight={400}
              color={"var(--color-label-employee)"}
              mb={"6px"}
            >
              Số ngày công chuẩn
            </FormLabel>
            <Input
              type="number"
              step="0.5"
              min={0}
              max={31}
              h={"44px"}
              borderRadius={"8px"}
              border={"1px solid var(--color-secondary)"}
              placeholder="Nhập số ngày công chuẩn"
              value={totalStandardWorking}
              onChange={(e) => setTotalStandardWorking(e.target.value)}
            />
          </FormControl>

          <Text mt={"12px"} fontSize={"12px"} color={"var(--color-label-employee)"}>
            Sửa số ngày công chuẩn của tất cả bản ghi trong tháng. Bản ghi đã
            chốt công được giữ nguyên.
          </Text>
          {isCurrentMonth && (
            <Text mt={"8px"} fontSize={"12px"} color={"var(--text-red-employee)"}>
              Tháng hiện tại hệ thống vẫn tự tính lại công chuẩn theo lịch chạy
              nên số vừa sửa có thể bị ghi đè. Nên sửa sau khi hết tháng hoặc
              chốt công ngay sau khi sửa.
            </Text>
          )}
        </ModalBody>
        <ModalFooter gap={"12px"}>
          <Button
            onClick={onClose}
            variant={"ghost"}
            borderRadius={"8px"}
            h={"44px"}
            fontSize={"15px"}
          >
            Hủy
          </Button>
          <Button
            onClick={handleUpdate}
            isLoading={isUpdating}
            loadingText="Đang cập nhật..."
            borderRadius={"8px"}
            background={"var(--linear-gradient-employee)"}
            color={"var(--color-main)"}
            h={"44px"}
            fontSize={"15px"}
            _hover={{ filter: "brightness(90%)" }}
          >
            Cập nhật
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default FormStandardWorking;
